import {
    createContext
} from 'react'

import { motion } from 'framer-motion'
import MuiDialog from '@mui/material/Dialog'
import Paper from '@mui/material/Paper'

const MotionPaper = motion.create(Paper)

export const DialogContext = createContext()

/**
 * @param context
 * @param {import('@mui/material/Dialog').DialogProps} props
 */
export default function MotionDialog({
    onClose,
    children,
    slotProps={},
    context={},
    ...rest
}) {
    return (
        <DialogContext.Provider value={context}>
            <MuiDialog
                open
                onClose={onClose}
                fullWidth
                maxWidth='xs'
                PaperComponent={MotionPaper}
                slotProps={{
                    ...slotProps,
                    paper: {
                        initial: { opacity: 0, scale: .8 },
                        animate: { opacity: 1, scale: 1 },
                        exit: { opacity: 0 },
                        transition: { duration: .15 },
                        ...slotProps.paper,
                    }
                }}
                {...rest}
            >
                {children}
            </MuiDialog>
        </DialogContext.Provider>
    )
}